import { Button as MUIButton, ButtonProps as MUIButtonProps } from "@material-ui/core";
import React from "react";

type Omitted =
  | 'value'

export interface ButtonProps extends Omit<MUIButtonProps, Omitted> {
  value: any;
}

export const Button = (props: ButtonProps) => {
  const {
    value,
    variant,
  } = props;

  return (
    <MUIButton
      {...props}
      variant={variant || "contained"}
    >
      {value}
    </MUIButton>
  );
}
